import api from '../..'

export const getEvaluationBlock = (blockId: number, preview = false) => {
  return api
    .get(
      `block_evaluation/block_instances/${blockId}${
        preview ? '?preview=true' : ''
      }`
    )
    .then(
      ({
        data: {
          data: { attributes },
        },
      }) => {
        const {
          id,
          approvalPoints,
          maxRetries,
          showResults,
          randomQuestions,
          questionsForms,
          blockInstanceable: {
            id: blockInstanceableId,
            lessonId,
            blockInstanceableType,
            name,
            description,
            order,
            mandatory,
          },
          evaluationsResult: {
            data: { attributes: results },
          },
        } = attributes
        const questionsAux = {
          id,
          lessonId,
          type: blockInstanceableType,
          name,
          description,
          order,
          mandatory,
          blockInstanceableId,
          config: { approvalPoints, maxRetries, showResults, randomQuestions },
          questions: [] as any,
          results,
        }

        questionsForms.map(
          ({
            id,
            name,
            order,
            description,
            explanationAnswer,
            questionableId,
            questionableType,
            blockInstanceableId,
            points,
            url,
            urlType,
            content,
            answer,
          }: any) => {
            const questionAux = {
              id,
              name,
              order,
              description,
              explanationAnswer,
              questionableId,
              questionableType,
              blockInstanceableId,
              points,
              url,
              urlType,
              content,
              answer,
            }
            questionsAux.questions.push(questionAux)
          }
        )
        return questionsAux
      }
    )
}
